import React, { useState } from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import {
  Button,
  alpha,
  styled,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import SeperateMembers from './SeperateMembers';
import { useAuthUser } from '@projectK/hooks/AuthHooks';
import PopupDialog from '@projectK/modules/apps/PopupDialog';
import { ParentsStudentListMain } from '@projectK/MainComponents';
import {isStudent,isActualSuperAdmin,isActualAdmin } from '@projectK/context/RolesProvider';
import { useSwitchBack } from "@projectK/hooks/SwitchBackHelper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  padding: 5,
  '&:first-of-type': {
    paddingLeft: 20,
  },
  '&:last-of-type': {
    paddingRight: 20,
  },
  '& .icon-btn': {
    border: `solid 1px ${alpha('#F84E4E', 1.0)}`,
    color: alpha('#F84E4E', 1.0),
    padding: 3,
    fontSize: 20,
    '&:not(:first-of-type)': {
      marginLeft: 8,
    },
  },

  '& .icon-btn-eye': {
    border: `solid 1px ${alpha(theme.palette.primary.main, 1.0)}`,
    color: alpha(theme.palette.primary.main, 1.0),
  },

  '&:hover': {
    '& .icon-btn': {
      border: `solid 1px #F84E4E`,
      color: '#F84E4E',
    },

    '& .icon-btn-eye': {
      border: `solid 1px ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
}));

const TableItem = ({
  data,
  onDelete,
  fetchMembersData,
  onSeperate,
  companyTheme,
}) => {
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [separateData, setSeparateData] = useState(null);
  const { user } = useAuthUser();
  const [roleAnchorEl, setRoleAnchorEl] = useState(null);
  const openModal = () => {
    setIsModalOpen(true);
    setSeparateData(data);
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const { switchBack } = useSwitchBack();

  const handleDelete = (itemId) => {
    setItemToDelete(itemId);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    isStudent(user) &&
    (isActualSuperAdmin(user) || isActualAdmin(user)) //useroletag
      ? onSeperate(itemToDelete)
      : onDelete(itemToDelete);
    setDeleteConfirmationOpen(false);
  };

  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
  };
  const handleSwitching = (user, data, event) => {
  const index = data.role_menu_flag.indexOf("student");
  
  const studentRoleId = data.role_ids[index];

 if (data.role_menu_flag.includes('student')) { //useroletag
      if (user.actualUser) {
        switchBack({
          id: data.id,
          role: studentRoleId,
          actualUser: user.actualUser,
          actualRole: user.actualRoleIds[0],
          parentuser: user.id,
          parentuserRoleId: user.roleIds[0]
        });
      } else {
        switchBack({
         id: data.id,
         role: studentRoleId,
         actualUser: user.id,
         actualRole: user.roleIds[0],
        });
      }
    }
  };

  const handleRoleCloseMenu = () => {
    setRoleAnchorEl(null);
  };

  return (
    <>
      <TableRow className='item-hover'>
        <ParentsStudentListMain
          data={data}
          user={user}
          roleAnchorEl={roleAnchorEl}
          handleSwitching={handleSwitching}
          openModal={openModal}
          companyTheme={companyTheme}
          switchBack={switchBack}
          handleRoleCloseMenu={handleRoleCloseMenu}
          handleDelete={handleDelete}
          StyledTableCell={StyledTableCell} 
          isStudentsList={true}
        />
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCancelDelete}
          maxWidth='xs'
        >
          <DialogTitle>
            <Typography variant='h4'>Confirm Deletion</Typography>
          </DialogTitle>
          <DialogContent>
            <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
              Are you sure you want to
              {isStudent(user) &&
               (isActualSuperAdmin(user) || isActualAdmin(user))
                ? ' separate '
                : ' delete '} 
              this member?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmDelete} color='primary'>
              Yes
            </Button>
            <Button onClick={handleCancelDelete} color='secondary'>
              No
            </Button>
          </DialogActions>
        </Dialog>
      </TableRow>
      <SeperateMembers
        data={separateData}
        isOpen={isModalOpen}
        onClose={closeModal}
        fetchMembersData={fetchMembersData}
        parentId={separateData?.id === user?.id ? data?.id : user?.id}
      />
      {isErrorDialogOpen && (
        <PopupDialog
          setIsErrorDialogOpen={setIsErrorDialogOpen}
          isErrorDialogOpen={isErrorDialogOpen}
        />
      )}
    </>
  );
};

export default TableItem;
TableItem.propTypes = {
  data: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  fetchMembersData: PropTypes.func,
  onSeperate: PropTypes.func,
  companyTheme: PropTypes.func,
};
